const pendingRequests = new Map();

// Share only concurrent reads. Settled responses are never cached here.
export const sharedRequest = (key, request) => {
  if (!pendingRequests.has(key)) {
    pendingRequests.set(
      key,
      Promise.resolve()
        .then(request)
        .finally(() => pendingRequests.delete(key))
    );
  }
  return pendingRequests.get(key);
};
